<template>
  <div class="row">
    <div class="col-md-8">
      <Title class="col-md-12 mb-2" :page="page" />
      <BreadCrumb :page="page" class="ml-3" />
    </div>
    <div class="col-md-4 text-right mt-4 mb-sm-4">
      <ActionButton
        class="btn btn-green outline-success"
        i="fas fa-arrow-circle-left"
        type="button"
        @click="$router.go(-1)"
      >
        Regresar
      </ActionButton>
      <ActionButton
        v-if="!readonly"
        class="btn btn-green success"
        i="fas fa-folder-tree"
        type="button"
        @click="linkAdmission()"
      >
        Vincular
      </ActionButton>
    </div>
    <div class="dropdown-divider mt-0 pb-2 w-100" />
    <div class="row-group w-100 pr-4 pl-3">
      <div v-if="!readonly" class="col-md-12">
        <section-title
          icon="fas fa-file-contract"
          content="Información de Servicio a Vincular"
          container-class="tag-badge-main-info mt-4 mb-4 font-size-sm"
        />
      </div>
      <div class="row">
        <div class="col">
          <service-info :item="info.serviceInfo" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <rejection-history
            :items="admissionrejectionhistory"
            @on-page-change="onPageChange"
          />
        </div>
      </div>
      <ValidationObserver v-if="!readonly" ref="formValidator">
        <div class="row">
          <div class="col mx-3">
            <ValidationProvider
              v-if="admissionrejectionhistory.count > 0"
              v-slot="{ errors }"
              rules="required"
            >
              <custom-checkbox-single-option
                v-if="admissionrejectionhistory.count > 0"
                v-model="info.acceptTerms"
                option-text="Certifico haber revisado el historial de rechazos de vinculación del servicio. (0696)"
                :error="errors[0]"
                custom-error-msg="Favor de certificar haber revisado el historial de rechazos del servicio."
                @input="onCheckTerms"
              />
            </ValidationProvider>
          </div>
        </div>
        <div
          v-if="info.acceptTerms || admissionrejectionhistory.count == 0"
          class="row"
        >
          <div class="col ml-3">
            <section-title
              content="Selección de Proveedor"
              container-class="mt-4 mb-4 main-title"
            />

            <div class="row mb-3">
              <div class="col">
                <div class="row-container pt-4">
                  <div class="col mb-2">
                    <i class="fa fa-info-circle mr-2 text-orange" />
                    <strong class="data-label">Información de Servicio</strong>
                  </div>
                  <div class="col ml-2">
                    <span class="data-label">Razón de Servicio:</span>
                    <p class="data">
                      {{ providerDetail.serviceReason | empty }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="mr-4">
              <div class="row">
                <div class="col-md-6 col-lg-4 mb-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <custom-date-picker
                      v-model="info.referralDate"
                      label="Fecha del Referido:"
                      :error="errors[0]"
                      :custom-error-msg="'Campo requerido.'"
                      :disabled="hasReferralDate"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-6 col-lg-4 mb-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <custom-date-picker
                      v-model="info.receiveDate"
                      label="Fecha Recibido:"
                      :error="errors[0]"
                      :custom-error-msg="'Campo requerido.'"
                      :disabled="hasReceiveDate"
                    />
                  </ValidationProvider>
                </div>
                <div class="mt-1 col-md-5 col-lg-4">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <custom-drop-down
                      v-model="info.selectedCenter"
                      label="Centro:"
                      :options="userCenters"
                      fieldkey="id"
                      fieldname="name"
                      placeholder="Seleccione"
                      :error="errors[0]"
                      custom-error-msg="Campo requerido."
                      :disabled="userCenters.length == 1"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div v-if="missingSelection" class="row mt-3">
                <div class="col">
                  <error
                    :message="messages.missingSelection"
                    variant="no-border"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col ml-3">
                  <!-- Escuela -->
                  <div class="row mt-4 row-container">
                    <div class="col-md-5">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="
                          rejection.one.wasRejected || schools.length == 0
                        "
                      >
                        <custom-drop-down
                          v-model="rejection.one.locationFiscalYearId"
                          label="Escuela:"
                          class="w-100"
                          :options="schools"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :disabled="
                            rejection.one.wasRejected || schools.length == 0
                          "
                          :error="rejection.one.wasRejected ? '' : errors[0]"
                          custom-error-msg="Campo requerido."
                        />
                      </ValidationProvider>
                    </div>
                    <div v-if="rejection.one.wasRejected" class="col-md-5">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="rejection.one.rejectionPlaceHolder != null"
                      >
                        <custom-drop-down
                          v-model="rejection.one.rejectionReasonId"
                          label="Razón de Rechazado:"
                          :options="reasons"
                          fieldkey="id"
                          fieldname="name"
                          :placeholder="
                            rejection.one.rejectionPlaceHolder || 'Seleccione'
                          "
                          :error="errors[0]"
                          custom-error-msg="Campo requerido."
                          :disabled="rejection.one.disabled"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-2 checkbox-aligment">
                      <div
                        class="custom-control custom-checkbox checkbox-top-spacing"
                      >
                        <input
                          id="chkRejectOne"
                          v-model="rejection.one.wasRejected"
                          type="checkbox"
                          name="chkRejectOne"
                          class="custom-control-input"
                          :disabled="schools.length == 0"
                          @change="onChangeRejectOne"
                        />
                        <label
                          for="chkRejectOne"
                          class="custom-control-label font regular"
                        >
                          <span><em class="ic-check" /></span>
                          Rechazar
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- Municipio Escuela -->
                  <div
                    v-if="rejection.one.wasRejected || schools.length == 0"
                    class="row mt-4 row-container"
                  >
                    <div class="col-md-5">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="
                          rejection.two.wasRejected ||
                            municipalitiesSchool.length == 0
                        "
                      >
                        <custom-drop-down
                          v-model="rejection.two.locationFiscalYearId"
                          label="Municipio Escuela:"
                          class="w-100"
                          :options="municipalitiesSchool"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :disabled="
                            rejection.two.wasRejected ||
                              municipalitiesSchool.length == 0
                          "
                          :error="rejection.two.wasRejected ? '' : errors[0]"
                          custom-error-msg="Campo requerido."
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-5">
                      <ValidationProvider
                        v-if="rejection.two.wasRejected"
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="rejection.two.rejectionPlaceHolder != null"
                      >
                        <custom-drop-down
                          v-model="rejection.two.rejectionReasonId"
                          label="Razón de Rechazado:"
                          :options="reasons"
                          fieldkey="id"
                          fieldname="name"
                          :placeholder="
                            rejection.two.rejectionPlaceHolder || 'Seleccione'
                          "
                          :error="errors[0]"
                          custom-error-msg="Campo requerido."
                          :disabled="rejection.two.disabled"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-2 checkbox-aligment">
                      <div
                        class="custom-control custom-checkbox checkbox-top-spacing"
                      >
                        <input
                          id="chkRejectTwo"
                          v-model="rejection.two.wasRejected"
                          type="checkbox"
                          name="chkRejectTwo"
                          class="custom-control-input"
                          :disabled="municipalitiesSchool.length == 0"
                          @change="onChangeRejectTwo"
                        />
                        <label
                          for="chkRejectTwo"
                          class="custom-control-label font regular"
                        >
                          <span><em class="ic-check" /></span>
                          Rechazar
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- Municipio Hogar -->
                  <div
                    v-if="
                      rejection.two.wasRejected ||
                        (schools.length == 0 &&
                          municipalitiesSchool.length == 0) ||
                        (rejection.one.wasRejected &&
                          municipalitiesSchool.length == 0)
                    "
                    class="row mt-4 row-container"
                  >
                    <div class="col-md-2">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="rejection.three.wasRejected"
                      >
                        <custom-drop-down
                          v-model="rejection.three.municipalityId"
                          label="Municipio Hogar:"
                          class="w-100"
                          :options="municipalitiesHome"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :disabled="rejection.three.wasRejected"
                          :error="errors[0] && !rejection.three.wasRejected"
                          custom-error-msg="Campo requerido."
                          @input="onChangeHomeMunicipality"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="rejection.three.wasRejected"
                      >
                        <custom-drop-down
                          v-model="rejection.three.locationFiscalYearId"
                          style="margin-top: 28px"
                          class="w-100"
                          :options="municipalitiesHomeSchools"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :disabled="rejection.three.wasRejected"
                          :error="errors[0] && !rejection.three.wasRejected"
                          custom-error-msg="Campo requerido."
                        />
                      </ValidationProvider>
                    </div>
                    <div v-if="rejection.three.wasRejected" class="col-md-5">
                      <ValidationProvider v-slot="{ errors }" rules="required">
                        <custom-drop-down
                          v-model="rejection.three.rejectionReasonId"
                          label="Razón de Rechazado:"
                          :options="reasons"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :error="errors[0]"
                          custom-error-msg="Campo requerido."
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-2 checkbox-aligment">
                      <div
                        class="custom-control custom-checkbox checkbox-top-spacing"
                      >
                        <input
                          id="chkRejectThird"
                          v-model="rejection.three.wasRejected"
                          type="checkbox"
                          name="chkRejectThird"
                          class="custom-control-input"
                          @change="onChangeRejectThird"
                        />
                        <label
                          for="chkRejectThird"
                          class="custom-control-label font regular"
                        >
                          <span><em class="ic-check" /></span>
                          Rechazar
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- Libre Selección -->
                  <div
                    v-if="rejection.three.wasRejected"
                    class="row mt-4 row-container"
                  >
                    <div class="col-md-2">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="rejection.four.wasRejected"
                      >
                        <custom-drop-down
                          v-model="rejection.four.municipalityId"
                          label="Libre Selección:"
                          class="w-100"
                          :options="municipalitiesFreeSelection"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :error="errors[0] && !rejection.four.wasRejected"
                          custom-error-msg="Campo requerido."
                          :disabled="rejection.four.wasRejected"
                          @input="onChangeFreeSelectionMunicipality"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        :disabled="rejection.four.wasRejected"
                      >
                        <custom-drop-down
                          v-model="rejection.four.locationFiscalYearId"
                          style="margin-top: 28px"
                          class="w-100"
                          :options="municipalitiesFreeSelectionSchools"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :error="errors[0] && !rejection.four.wasRejected"
                          custom-error-msg="Campo requerido."
                          :disabled="rejection.four.wasRejected"
                        />
                      </ValidationProvider>
                    </div>

                    <div v-if="rejection.four.wasRejected" class="col-md-5">
                      <ValidationProvider v-slot="{ errors }" rules="required">
                        <custom-drop-down
                          v-model="rejection.four.rejectionReasonId"
                          label="Razón de Rechazado:"
                          :options="reasons"
                          fieldkey="id"
                          fieldname="name"
                          placeholder="Seleccione"
                          :error="errors[0]"
                          custom-error-msg="Campo requerido."
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-md-2 checkbox-aligment">
                      <div
                        class="custom-control custom-checkbox checkbox-top-spacing"
                      >
                        <input
                          id="chkRejectForth"
                          v-model="rejection.four.wasRejected"
                          type="checkbox"
                          name="chkRejectForth"
                          class="custom-control-input"
                          @change="onChangeRejectFourth"
                        />
                        <label
                          for="chkRejectForth"
                          class="custom-control-label font regular"
                        >
                          <span><em class="ic-check" /></span>
                          Rechazar
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navigate-to-provider-selection" />
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Title from '@/components/common/page/Title';
import BreadCrumb from '@/components/common/page/BreadCrumb';
import { SectionTitle } from '@/components/pei/shared';
import ActionButton from '@/components/common/ActionButton';
import { ServiceInfo, RejectionHistory } from './components/link';
import CustomCheckboxSingleOption from '@/components/common/CustomCheckboxSingleOption';
import { CustomDatePicker, CustomDropDown, Error } from '@/components/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import alertMixin from '@/mixin/alert.mixin';
import moment from 'moment';
import { modulesName } from '@/modules';
const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
  modulesName.referralModuleName
);
import { mapGetters as appMapGetters } from 'vuex';
import * as referralTypes from '@/modules/referral/store/types.js';
const NAVIGATION_CLASS_ELEMENT = '.navigate-to-provider-selection';

const NO_DISPONIBILIDAD_SERVICIO = 'No hay disponibilidad de servicio';

export default {
  name: 'SeleccionProveedores',
  mixins: [alertMixin],
  components: {
    Title,
    BreadCrumb,
    SectionTitle,
    ActionButton,
    ServiceInfo,
    RejectionHistory,
    CustomCheckboxSingleOption,
    CustomDatePicker,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
    Error,
  },
  computed: {
    ...appMapGetters({
      centersAssigned: 'userCentersAssigned',
    }),
    ...mapState({
      referralFilters: (state) => state.referral.filters.lastFiltered,
      admissionrejectionhistory: (state) => {
        return state.link.admissionrejectionhistory;
      },
      schools: (state) => state.link.providerSchools,
      centers: (state) => state.referral.serviceCenters,
      reasons: (state) => state.link.providerReasons,
      providerDetail: (state) => state.link.providerDetail,
      municipalitiesSchool: (state) => state.link.municipalitiesSchool,
      municipalitiesHome: (state) => state.link.municipalitiesHome,
      municipalitiesFreeSelection: (state) =>
        state.link.municipalitiesFreeSelection,
      municipalitiesHomeSchools: (state) =>
        state.link.municipalitiesHomeSchools,
      municipalitiesFreeSelectionSchools: (state) =>
        state.link.municipalitiesFreeSelectionSchools,
    }),
    hasReferralDate() {
      return this.providerDetail?.referralDate ? true : false;
    },
    hasReceiveDate() {
      return this.providerDetail?.receivedDate ? true : false;
    },
    userCenters() {
      return this.centersAssigned(this.centers);
    },
  },
  data: () => ({
    page: {
      icon: 'fas fa-user-circle',
      title: 'Selección de Proveedores',
      routes: ['Inicio', 'PEI', 'Manejo de Referidos', 'Seguimiento'],
    },
    rejection: {
      one: {
        municipalityId: null,
        locationFiscalYearId: null,
        rejectionReasonId: null,
        wasRejected: false,
        isSelectedFlag: false,
        optionId: 1,
      },
      two: {
        municipalityId: null,
        locationFiscalYearId: null,
        rejectionReasonId: null,
        wasRejected: false,
        isSelectedFlag: false,
        optionId: 2,
      },
      three: {
        municipalityId: null,
        locationFiscalYearId: null,
        rejectionReasonId: null,
        wasRejected: false,
        isSelectedFlag: false,
        optionId: 3,
      },
      four: {
        municipalityId: null,
        locationFiscalYearId: null,
        rejectionReasonId: null,
        wasRejected: false,
        isSelectedFlag: false,
        optionId: 4,
      },
    },
    info: {
      referralDate: null,
      receiveDate: null,
      acceptTerms: null,
      selectedCenter: null,
      serviceInfo: {
        studentName: '',
        studentSieId: '',
        referralNumber: '',
        disciplineName: '',
      },
      admissionId: '',
      studentServiceId: '',
    },
    pageConfig: {
      pageNumber: 1,
      pageSize: 5,
    },
    messages: {
      missingSelection:
        'Para guardar el vínculo, se debe seleccionar un proveedor en una de las opciones provista. (0449)',
    },
    readonly: false,
    missingSelection: false,
  }),
  mounted() {
    const paramsFromRoute = this.$root.$route.params;
    this.info = {
      ...this.info,
      ...paramsFromRoute,
      referralDate: paramsFromRoute.referralDate
        ? moment(paramsFromRoute.referralDate).toDate()
        : null,
      receiveDate: paramsFromRoute.receivedDate
        ? moment(paramsFromRoute.referralDate).toDate()
        : null,
    };
    this.admissionId = paramsFromRoute?.admissionId;
    this.readonly = paramsFromRoute?.isReadonly;
    //get history
    this.onGetHistory(this.admissionId, this.pageConfig);

    //auto assign current center (if apply)
    if (this.userCenters.length == 1) {
      this.info.selectedCenter = this.userCenters[0];
    }
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.scrolledToBottom = true;
        }
      };
    },
    scrollToClass(className) {
      // Get the first element with the given class name
      let el = this.$el.querySelector(className);
      // Get the bounding rectangle so we can get the element position position
      let rect = el.getBoundingClientRect();
      // Scroll to the element (using x and y axis)
      window.scrollTo(rect.left, rect.top);
    },
    async linkAdmission() {
      const formValid = await this.$refs.formValidator.validate();
      if (formValid) {
        const _missingSelection = this.evalSelectedProvider();
        if (!_missingSelection) {
          this.missingSelection = true;
          this.ShowToast('Error', this.messages.missingSelection, 'error');
          this.scrollToClass(NAVIGATION_CLASS_ELEMENT);
          return;
        }
        const dataToSend = [];
        for (let key in this.rejection) {
          const prop = this.rejection[key];
          const mappedProp = {
            admissionId: this.admissionId,
            studentServiceId: this.info.serviceInfo?.studentServiceId,
            serviceCenterId: this.info.selectedCenter?.id ?? null,
            referralDate: this.info.referralDate,
            receivedDate: this.info.receiveDate,
            municipalityId: prop.municipalityId?.id ?? null,
            locationFiscalYearId: prop.locationFiscalYearId?.id ?? null,
            rejectionReasonId: prop.rejectionReasonId?.id ?? null,
            wasRejected: prop.wasRejected,
            optionId: prop.optionId,
            isSelectedFlag: prop.isSelectedFlag,
          };
          dataToSend.push(mappedProp);
        }

        try {
          await this.saveRejectionLinkAdmission(dataToSend);

          //auto filter on complete save
          this.getReferrals({ filters: this.referralFilters });

          //go back
          this.$router.go(-1);

          //show success toaster
          this.ShowToast(
            'Notificación',
            'Los datos fueron guardados exitosamente.',
            'success'
          );
        } catch (err) {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        }
      } else {
        this.missingSelection = false;
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada para continuar.',
          'error'
        );
        this.scrollToClass(NAVIGATION_CLASS_ELEMENT);
      }
    },
    async onGetHistory(admissionId, pageConfig) {
      await this[referralTypes.ACTION_TYPES.GET_ADMISSION_REJECTION_HISTORY]({
        admissionId,
        pageConfig,
      });
      if (this.admissionrejectionhistory.count == 0) {
        this.onCheckTerms();
      }
    },
    onPageChange(params) {
      this.onGetHistory(this.admissionId, {
        ...this.pageConfig,
        pageNumber: params.currentPage,
      });
    },
    async onCheckTerms() {
      //get schools
      await this.getSchoolByAdmissionId(this.admissionId);

      //if schools is empty skip rejection and move on
      if (this.schools.length == 0) {
        this.onSetAutoRejection('one');
        await this.getSchoolMunicipality({
          admissionId: this.admissionId,
        });
        if (
          this.schools &&
          this.schools.length == 0 &&
          this.municipalitiesSchool &&
          this.municipalitiesSchool.length == 0
        ) {
          this.onSetAutoRejection('two');
          await this.getSchoolHome({
            admissionId: this.admissionId,
          });
          this.onSetIsSelectedFlag('three', true);
        } else {
          this.onSetIsSelectedFlag('two', true);
        }
      } else {
        this.onSetIsSelectedFlag('one', true);
      }

      //get centers
      this.getBillingCenters();

      //get reasons
      this.getProviderReasons();

      //get provider detail and assign default dates
      await this.getProviderDetail(this.admissionId);

      this.info = {
        ...this.info,
        referralDate: this.providerDetail?.referralDate
          ? moment(this.providerDetail?.referralDate).toDate()
          : null,
        receiveDate: this.providerDetail?.receivedDate
          ? moment(this.providerDetail?.receivedDate).toDate()
          : null,
      };
      this.scrollToClass(NAVIGATION_CLASS_ELEMENT);
    },
    onSetAutoRejection(number) {
      this.rejection[number].wasRejected = true;
      this.rejection[number].disabled = true;
      this.rejection[number].rejectionPlaceHolder = NO_DISPONIBILIDAD_SERVICIO;
    },
    onSetIsSelectedFlag(number, value) {
      this.rejection.one.isSelectedFlag = false;
      this.rejection.two.isSelectedFlag = false;
      this.rejection.three.isSelectedFlag = false;
      this.rejection.four.isSelectedFlag = false;
      this.rejection[number].isSelectedFlag = value;
    },
    onClearPreviousSelection(number) {
      this.rejection[number].rejectionReasonId = null;
      this.rejection[number].municipalityId = null;
      this.rejection[number].locationFiscalYearId = null;
    },
    async onChangeRejectOne() {
      if (this.rejection.one.wasRejected) {
        this.rejection.one.locationFiscalYearId = null;
        this.onSetIsSelectedFlag('two', true);
        this.onClearPreviousSelection('one');

        await this.getSchoolMunicipality({
          admissionId: this.admissionId,
        });
        if (this.municipalitiesSchool.length == 0) {
          this.onSetAutoRejection('two', true);
          this.onSetIsSelectedFlag('two', false);
          this.onSetIsSelectedFlag('three', true);
          await this.getSchoolHome({
            admissionId: this.admissionId,
          });
        }
        this.scrollToClass(NAVIGATION_CLASS_ELEMENT);
      } else {
        this.rejection.two.wasRejected = false;
        this.rejection.three.wasRejected = false;
        this.rejection.four.wasRejected = false;

        this.onClearPreviousSelection('two');
        this.onClearPreviousSelection('three');
        this.onClearPreviousSelection('four');
        this.onSetIsSelectedFlag('one', true);
      }
    },
    onChangeRejectTwo() {
      if (this.rejection.two.wasRejected) {
        this.rejection.two.locationFiscalYearId = null;
        this.onSetIsSelectedFlag('three', true);
        this.onClearPreviousSelection('two');
        this.getSchoolHome({
          admissionId: this.admissionId,
        });
        this.scrollToClass(NAVIGATION_CLASS_ELEMENT);
      } else {
        this.rejection.three.wasRejected = false;

        this.onClearPreviousSelection('three');
        this.onClearPreviousSelection('four');
        this.onSetIsSelectedFlag('two', true);
      }
    },
    onChangeRejectThird() {
      if (this.rejection.three.wasRejected) {
        this.rejection.three.municipalityId = null;
        this.rejection.three.locationFiscalYearId = null;
        this.onSetIsSelectedFlag('four', true);
        this.onClearPreviousSelection('three');
        this.getSchoolFreeSelection({
          admissionId: this.admissionId,
        });
        this.scrollToClass(NAVIGATION_CLASS_ELEMENT);
      } else {
        this.rejection.four.wasRejected = false;
        this.onClearPreviousSelection('four');
        this.onSetIsSelectedFlag('three', true);
      }
    },
    onChangeRejectFourth() {
      if (this.rejection.four.wasRejected) {
        this.rejection.four.municipalityId = null;
        this.rejection.four.locationFiscalYearId = null;
      } else {
        this.missingSelection = false;
      }
    },
    onChangeHomeMunicipality(selected) {
      if (selected?.id) {
        this.getSchoolHomeMunicipalitySchool({
          admissionId: this.admissionId,
          municipalityId: selected.id,
        });
      }
    },
    onChangeFreeSelectionMunicipality(selected) {
      if (selected?.id) {
        this.getSchoolFreeSelectionMunicipalitySchool({
          admissionId: this.admissionId,
          municipalityId: selected.id,
        });
      }
    },
    evalSelectedProvider() {
      let hasSelection = false;
      for (let key in this.rejection) {
        if (key === 'one' && this.rejection[key].locationFiscalYearId) {
          return true;
        }
        if (key === 'two' && this.rejection[key].locationFiscalYearId) {
          return true;
        }
        if (
          this.rejection[key].municipalityId &&
          this.rejection[key].locationFiscalYearId
        ) {
          return true;
        }
      }
      return hasSelection;
    },
    ...mapMutations(['setLinkUpdateInfo']),
    ...mapActions([
      referralTypes.ACTION_TYPES.GET_ADMISSION_REJECTION_HISTORY,
      'getSchoolByAdmissionId',
      'getProviderReasons',
      'getBillingCenters',
      'getProviderReasons',
      'getProviderDetail',
      'getSchoolMunicipality',
      'getSchoolHome',
      'getSchoolFreeSelection',
      'getSchoolHomeMunicipalitySchool',
      'getSchoolFreeSelectionMunicipalitySchool',
      'saveRejectionLinkAdmission',
      'getReferrals',
    ]),
  },
};
</script>

<style scoped lang="scss">
.row-container {
  background-color: #f7f7f7;
  padding: 20px;
  border-radius: 5px;
}

.checkbox-aligment {
  margin-top: 30px;
}
</style>
